import React, { useState } from 'react';
import { Alert, AlertTitle, Box, Grid, TextField, Button, Dialog, DialogActions, useTheme, useMediaQuery } from '@mui/material';
import {
  Delete as DeleteIcon,
  Refresh as RefreshIcon,
} from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { deletePixel } from '../../../actions/pixel';

export default function DeleteConfirmationDialog(props) {

  const { openDialog, setOpenDialog, pixel_key, user_key } = props;
  const dispatch = useDispatch();

  const [ data, setData ] = useState('');

  const deleteCode = `delete ${pixel_key?.substring(0,6)}`;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleDataChange = (event) => {
    const { value } = event.target;
    setData(value);
  };

  const handleClose = () => {
    setOpenDialog(false);
    setData('');
  };

  const handleDelete = () => {
    handleClose();
    dispatch(deletePixel({
      pixel_key,
      user_key,
    }));
  }

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="pixel-delete-confirmation"        
      >
        <Grid container id="pixel-delete-confirmation">
          <Grid item xs={12}>
            <Alert
              icon={<DeleteIcon fontSize="inherit" />} 
              severity="error"
              variant="outlined"
              sx={{ boxShadow: 10, borderRadius: 1, m: 1, p: 2, pb: 0 }}
            >
              <AlertTitle>
                <strong>Permanently delete this Pixel?</strong>
              </AlertTitle>
              <Box sx={{ mt: 1 }}>
                You will no longer have access to a permanently deleted Pixel. There is no option to undo this operation.
              </Box>
              <Box sx={{ mt: 1 }}>
                Please confirm the Pixel deletion by typing: <strong>{deleteCode}</strong>
              </Box>
              <TextField
                focused={true}
                type="text"
                name="delete_code"
                placeholder={deleteCode}
                variant="standard"
                size='small'
                margin='normal'
                fullWidth
                required={false}
                multiline={false}
                rows={1}
                value={data}
                onChange={handleDataChange}
                color="error"
                sx={{ pr: 1 }}
              />
              <DialogActions>
                <Button
                  type="submit"
                  variant="outlined"
                  color="error"
                  onClick={handleClose}
                  startIcon={<RefreshIcon />}
                  sx={{ boxShadow: 10 }}
                >
                  {"Cancel"}
                </Button>
                <Button
                  type="submit"
                  variant="outlined"
                  color="error"
                  onClick={handleDelete}
                  startIcon={<DeleteIcon />}
                  sx={{ boxShadow: 10 }}
                  disabled={data === deleteCode ? false : true}
                >
                  {"Delete Pixel"}
                </Button>
              </DialogActions>
            </Alert>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
}
